<template>
  <v-card
    color="white"
    class="rounded-sm no-scroll"
    height="auto"
  >
    <div class="dialog-card-auto pa-8 d-flex flex-column">
      <v-form v-model="movementForm">
        <span class="form-label">Categoría</span>
        <v-row class="d-flex align-end mb-2">
          <v-col
            cols="10"
            class="d-flex"
          >
            <v-select
              v-model="computedMovementCategory"
              :items="categories"
              outlined
              hide-details
              dense
              class="mt-2 self-center"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <div
              :style="{
                backgroundColor: newMovementForm.color,
                height: '40px',
                border: '2px solid #31384b',
                borderRadius: '5px',
              }"
            ></div>
          </v-col>
          <v-col
            cols="12"
            v-if="newMovementForm.category == 'Movimiento'"
          >
            <span class="form-label">Tipo de movimiento</span>
            <v-select
              :items="categoryOptions[newMovementForm.category]"
              v-model="newMovementForm.movementType"
              outlined
              hide-details
              dense
              class="mt-2 self-center"
            ></v-select>
          </v-col>
        </v-row>
        <section
          v-if="newMovementForm.category == 'Evento'"
          class="mt-4"
        >
          <span class="form-label"> Evento </span>
          <v-combobox
            outlined
            dense
            class="mt-2"
            :items="eventList"
            v-model="eventSelected"
          >
          </v-combobox>
          <span class="form-label">Grupo</span>
          <UtilityCombo
            :comboType="'IMEF_GROUP'"
            :comboList="IMEF_GROUPS"
            :defVal="{
              text: newMovementForm.organizator,
              value: newMovementForm.organizator,
            }"
            @setUtility="updateGroup"
            dense
            outlined
          />
          <span class="form-label"> Tipo de evento </span>
          <v-select
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.eventType"
            :items="IMEF_SERVICES"
          />
          <span class="form-label"> Acceso </span>
          <v-combobox
            outlined
            dense
            class="mt-0"
            :items="eventSelected.tickets"
            v-model="accessSelected"
          >
          </v-combobox>
          <span class="form-label"> Puntos EPC </span>
          <v-text-field
            outlined
            dense
            type="number"
            class="mt-2"
            :rules="epcRules"
            :min="0"
            v-model="newMovementForm.points"
          />
          <span class="form-label"> CEPLAN Presencial </span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.ceplan"
          />
          <span class="form-label"> CEPLAN Virtual </span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.ceplanv"
          />
        </section>

        <section v-if="newMovementForm.category == 'Consejo Directivo'">
          <span class="form-label">Grupo</span>
          <UtilityCombo
            :comboType="'IMEF_GROUP'"
            :comboList="IMEF_GROUPS"
            :defVal="{
              text: newMovementForm.organizator,
              value: newMovementForm.organizator,
            }"
            @setUtility="updateGroup"
            dense
            outlined
          />
          <span class="form-label">Año lectivo</span>
          <v-text-field
            outlined
            dense
            type="number"
            class="mt-2"
            v-model="newMovementForm.year"
          />
          <span class="form-label">Posición</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.position"
          />
        </section>

        <section v-if="newMovementForm.category == 'Consejo Consultivo'">
          <span class="form-label">Grupo</span>
          <UtilityCombo
            :comboType="'IMEF_GROUP'"
            :comboList="IMEF_GROUPS"
            :defVal="{
              text: newMovementForm.organizator,
              value: newMovementForm.organizator,
            }"
            @setUtility="updateGroup"
            dense
            outlined
          />
          <span class="form-label">Año lectivo</span>
          <v-text-field
            outlined
            dense
            type="number"
            class="mt-2"
            v-model="newMovementForm.year"
          />
          <span class="form-label">Posición</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.position"
          />
        </section>

        <section v-if="newMovementForm.category == 'Comité Técnico'">
          <span class="form-label">Grupo</span>
          <UtilityCombo
            :comboType="'IMEF_GROUP'"
            :comboList="IMEF_GROUPS"
            :defVal="{
              text: newMovementForm.organizator,
              value: newMovementForm.organizator,
            }"
            @setUtility="updateGroup"
            dense
            outlined
          />
          <span class="form-label mt-2">Tipo de comité</span>
          <v-select
            outlined
            dense
            :items="IMEF_COMMITTEE"
            v-model="newMovementForm.committeeType"
          ></v-select>
          <span class="form-label">Posición</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.position"
          />
          <span class="form-label">Año</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            type="number"
            v-model="newMovementForm.year"
          />
          <span class="form-label">Tema</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.topic"
          />
        </section>

        <section v-if="newMovementForm.category == 'Contribución'">
          <span class="form-label">Grupo</span>
          <UtilityCombo
            :comboType="'IMEF_GROUP'"
            :comboList="IMEF_GROUPS"
            :defVal="{
              text: newMovementForm.organizator,
              value: newMovementForm.organizator,
            }"
            @setUtility="updateGroup"
            dense
            outlined
          />
          <span class="form-label">Tipo de contribución</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.contributionType"
          />

          <span class="form-label">Participación</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.participation"
          />

          <span class="form-label">Puntos EPC</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            type="number"
            :rules="epcRules"
            :min="0"
            v-model="newMovementForm.points"
          />

          <span class="form-label">Medio de publicación</span>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newMovementForm.publicationMedium"
          />
        </section>

        <section class="d-flex flex-column">
          <span class="form-label">Descripción</span>
          <v-textarea
            v-model="newMovementForm.description"
            outlined
            dense
            height="112px"
            class="mt-2"
          ></v-textarea>

          <span class="form-label">Fecha</span>
          <v-menu
            v-model="newMovementDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :rules="[(v) => !!v || 'El rango de fechas es inválido']"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="button mt-2"
                outlined
                large
              >
                <v-row
                  align="center"
                  class="px-2"
                >
                  <v-icon
                    color="grey lighten-1"
                    size="20"
                    class="mr-2"
                    >mdi-calendar-outline</v-icon
                  >
                  <span class="button-text grey--text text--lighten-1">
                    {{
                      computedMovementDate != ""
                        ? computedMovementDate
                        : "Selecciona una fecha"
                    }}
                  </span>
                </v-row>
              </v-btn>
            </template>
            <v-date-picker
              v-model="computedMovementDate"
              locale="es"
              no-title
            ></v-date-picker>
          </v-menu>
          <v-btn
            class="mr-2 mt-4 button white--text mb-4"
            large
            :disabled="!movementForm"
            color="#1b273e"
            @click="updateMovement()"
          >
            <span class="button-text white--text">Guardar</span>
          </v-btn>
        </section>
        <hr />
      </v-form>
    </div>
  </v-card>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { IMEF_MOVEMENTS_DICT } from "../../../share/imef";
import UtilityCombo from "../../shared/UtilityCombo.vue";

export default {
  components: {
    UtilityCombo
  },
  props: {
    movement: {
      type: Object,
      required: true
    },
    memberId: {
      type: String,
      required: true
    },
    headOffice: {
      type: String,
      default: ""
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IMEF_MOVEMENTS_DICT,
      IMEF_GROUPS: [],
      IMEF_SERVICES: [],
      IMEF_COMMITTEE: [],
      movementForm: false,
      newMovementDateMenu: false,
      eventSelected: "",
      accessSelected: null,
      newMovementForm: {
        title: "",
        movementType: "",
        description: "",
        date: "",
        color: "#000",
        category: "",
        points: "",
        organizator: "",
        ceplan: "",
        ceplanv: "",
        eventType: "",
        contributionType: "",
        participation: "",
        publicationMedium: "",
        year: "",
        position: "",
        committeeType: "",
        topic: ""
      },
      categories: [
        "Movimiento",
        "Evento",
        "Consejo Directivo",
        "Consejo Consultivo",
        "Comité Técnico",
        "Contribución"
      ],
      categoryOptions: {
        Movimiento: [
          "Ingreso",
          "Baja",
          "Cambio de categoría",
          "Reingreso",
          "Cambio de grupo",
          "Fallecimiento",
          "Año de Gracia"
        ]
      },
      categoriesColors: {
        Movimiento: "#FF5733",
        Evento: "#33FF57",
        "Consejo Directivo": "#3357FF",
        "Consejo Consultivo": "#FF33A1",
        "Comité Técnico": "#FF8C33",
        Contribución: "#33FFF5"
      },
      epcRules: [(v) => v >= 0 || "El valor ingresado es inválido"]
    };
  },
  methods: {
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),
    ...mapActions("event", ["fetchEventsList"]),
    
    setCategoryColor(category) {
      this.newMovementForm.color = this.categoriesColors[category];
    },
    
    async updateGroup({ newValue = "", updateList = false }) {
      this.newMovementForm.organizator = newValue;
      if (updateList) {
        await this.$_fetchImefUtilities();
      }
    },
    
    async $_fetchImefUtilities() {
      try {
        let response = await this.axios({
          method: "GET",
          url: "/utilities/fetch-utilities",
          params: {
            utilityTypes: ["IMEF_GROUP", "IMEF_EVENT", "IMEF_COMMITTEE"]
          }
        });

        if (response.status == 200) {
          const {
            IMEF_GROUP = [],
            IMEF_EVENT = [],
            IMEF_COMMITTEE = []
          } = response.data.utilityLoad;
          this.IMEF_GROUPS = IMEF_GROUP;
          this.IMEF_SERVICES = IMEF_EVENT;
          this.IMEF_COMMITTEE = IMEF_COMMITTEE;
        }
      } catch (error) {
        console.log(error);
      }
    },
    
    // Cargar los datos del movimiento para editar
    loadMovementData() {
      // Asignar datos del movimiento a editar al formulario
      Object.keys(this.newMovementForm).forEach(key => {
        if (this.movement[key] !== undefined) {
          this.newMovementForm[key] = this.movement[key];
        }
      });
      
      // Si es un evento, seleccionar el evento correcto
      if (this.newMovementForm.category === 'Evento' && this.eventList.length > 0) {
        this.eventSelected = this.eventList.find(event => 
          event.title === this.movement.title
        ) || "";
        
        // Si hay tickets en el evento, seleccionar el acceso correcto
        if (this.eventSelected && this.eventSelected.tickets) {
          this.accessSelected = this.eventSelected.tickets.find(ticket => 
            ticket.imefPoints === this.movement.points.toString()
          ) || null;
        }
      }
    },
    
    // Actualizar el movimiento
    async updateMovement() {
      this.loading();
      try {
        const response = await this.axios({
          method: "PUT",
          url: `/movements/${this.movement._id}`,
          data: {
            ...this.newMovementForm,
            memberId: this.memberId,
            headOffice: this.headOffice
          }
        });

        if (response.data) {
          this.show({
            text: "¡El movimiento se ha actualizado correctamente!",
            color: "success"
          });
          this.$emit('movement-updated');
        }
      } catch (error) {
        console.log(error);
        this.show({
          text: "Hubo un error al actualizar el movimiento, por favor intenta nuevamente",
          color: "error"
        });
      } finally {
        this.loaded();
        this.$emit('close-dialog');
      }
    },
    
    closeDialog() {
      this.$emit('close-dialog');
    }
  },
  
  computed: {
    ...mapState("event", ["eventList"]),
    computedMovementCategory: {
      get() {
        if (this.newMovementForm.category && this.newMovementForm.category != "" && this.categories.includes(this.newMovementForm.category)) {
          return this.newMovementForm.category;
        }
        return 'Movimiento';
      },
      set(newCategory) {
        this.newMovementForm.category = newCategory;
        this.setCategoryColor(newCategory);
      }
    },

    computedMovementDate: {
      get() {
        let localeDate = new Date(this.newMovementForm.date);
        localeDate = localeDate.toLocaleDateString("es-MX", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        });

        const splittedDate = localeDate.split("/");
        const formattedDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        return formattedDate;
      },
      set(newDate) {
        this.newMovementForm.date = newDate;
      }
    }
  },
  
  watch: {
    movement: {
      immediate: true,
      handler() {
        if (this.movement) {
          this.loadMovementData();
        }
      }
    },
    
    dialog: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadMovementData();
        }
      }
    },
    
    "newMovementForm.category": {
      handler(newCategory) {
        this.setCategoryColor(newCategory);
      },
      deep: true
    },
    
    eventSelected: {
      deep: true,
      handler(event) {
        if (event && event.movementSetup) {
          this.updateGroup({ newValue: event.movementSetup.organizator || "" });
          this.newMovementForm.eventType = event.movementSetup.eventType || "";
        }
      }
    },
    
    accessSelected: {
      deep: true,
      handler(access) {
        if (access && access.ticketCeplan) {
          this.newMovementForm.points = access.imefPoints;
          this.newMovementForm.ceplan =
            [...access.ticketCeplan].find(
              (element) => element.item == "PRESENTIAL"
            )?.value || "N/A";
          this.newMovementForm.ceplanv =
            [...access.ticketCeplan].find(
              (element) => element.item == "VIRTUAL"
            )?.value || "N/A";
        }
      }
    }
  },
  
  async created() {
    await this.fetchEventsList();
    await this.$_fetchImefUtilities();
  }
};
</script>
